import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=60e95dd9&"
import script from "./VideosList.vue?vue&type=script&lang=ts&"
export * from "./VideosList.vue?vue&type=script&lang=ts&"
import style0 from "./VideosList.vue?vue&type=style&index=0&id=60e95dd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports